module.exports = __webpack_public_path__ + "static/img/qa.ea280a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/lesson-question/qa.png
// module id = sCsp
// module chunks = 1